import {useEffect, useState} from 'react';
import {
  CartProvider,
  Image,
  Link,
  useCart,
  useNavigate,
  useRouteParams,
  useServerProps,
} from '@shopify/hydrogen';

import CartToggle from './CartToggle.client';
import {useCartUI} from './CartUIProvider.client';
import logo from '../assets/image/logo-el-librero.svg';
import books from '../assets/image/books.svg';
import close from '../assets/image/close-icon.svg';
import '../assets/css/custom.css';
import {getPath} from '../lib/methods';
import MobileNavigation from './MobileNavigation.client';
import SearchForm from './Search.client';
import CartIcon from './CartIcon';
import Loader from './Loader.client';
import ReactGA from 'react-ga';
import CouponModalComponent from './modal/Coupon.client';
import SearchBar from './listproductsfilters/SearchBar.client';
import SearchIcon from '../assets/image/search-icons/search-mobile-button.svg';
import { isMobile, valueByEnviromentExtend } from '../lib/Utils';
import { useAppDispatch } from '../lib/hooks';
import { buttonPhone } from '../store/slices/searchui';
import { FaTree, FaGift } from "react-icons/fa";
import { DRUID_AUTH_URL, DRUID_CLIENT } from '../config';

/**
 * A client component that specifies the content of the header on the website
 */
export default function Header({collections, menu, customerAccessToken}) {
  const dispatch = useAppDispatch();
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [selectedTitle, setTitle] = useState('');
  const [currentPage, setCurrentPage] = useState('');
  const [scrollbarWidth, setScrollbarWidth] = useState(0);
  const [isCartUpdateKey, setIsCartUpdateKey] = useState(null);
  const {isCartOpen} = useCartUI();
  const [offset, setOffset] = useState(0);
  const {pending} = useServerProps();
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [pageViewCount, setPageVisitCount] = useState(0);
  const [timeOutMenu, setTimeOutMenu] = useState(400);
  const [isActiveSearch, setIsActiveSearch] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [toggleMessage, setToggleMessage] = useState(true);
  const [slideNumber, setSlideNumber] = useState(1);
  const [removeTopBar, setRemoveTopBar] = useState(false);
  const [loginUrl, setLoginUrl] = useState('');

  const handleLineUpdate = () => {
  };

  ReactGA.initialize('UA-116858775-2');

  const getScrollPercentage = () => {
    const h = document.documentElement,
      b = document.body,
      st = 'scrollTop',
      sh = 'scrollHeight';
    const scrollPercentage =
      ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;

    dataLayer.push({
      event: 'scroll_percent',
      scrollPercentage: `${scrollPercentage.toFixed(2)}%`,
    });
  };

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener('scroll', () => {
      setScroll(window.scrollY > 50);

      if (window.scrollY > 50) {
        getScrollPercentage();
      }
      
      const scrollPositionY = document.documentElement.scrollTop || document.body.scrollTop || 0;
      if(scrollPositionY < 50){
        setRemoveTopBar(false);
      }else{
        setRemoveTopBar(true);
      }
    });
  
    const interval = setInterval(() => {
      try{
        setSlideNumber((prevSlideNumber) => {
          if (prevSlideNumber === 1) {
            return 2;
          } else if (prevSlideNumber === 2) {
            return 1;
          }
        });
      }catch(e){}
    }, 5000);

    setLoginUrl(valueByEnviromentExtend(
      'http%3A%2F%2Flocalhost%3A3000%2Faccount%2Flogin',
      'https%3A%2F%2Flibrero-larousse-book-shopify-hydrogen-git-ac9f6a-montalvo-wire.vercel.app%2Faccount%2Flogin', 
      'https%3A%2F%2Fwww.ellibrero.com%2Faccount%2Flogin'
    ));

    return () => {
      try{
        clearInterval(interval);
      }catch(e){}
    };
  }, []);

  useEffect(() => {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    setScrollbarWidth(scrollbarWidth);
  }, [isCartOpen]);

  useEffect(() => {
    setInterval(() => {
      const isCartUpdated = localStorage.getItem('isCartUpdateKey');
      if (isCartUpdateKey != isCartUpdated) {
        setIsCartUpdateKey(isCartUpdated);
      }
    }, 500);
  }, []);

  useEffect(() => {
    window.addEventListener('locationchange', function () {
    });
  }, []);
  
  useEffect(() => {
    window.onmouseover = function (e) {
      const escape = ['nav-submenu-wrapper', 'top-header-wrapper'];
      try{
        if (e?.target?.className) {
          if (e.target.className?.includes(' ')) {
            const classArray = e.target.className.split(' ');
            classArray.forEach((item) => {
              if (escape.includes(item)) {
                setTitle('');
              }
            });
          }
        }
      }catch(e){
      }
    };
  }, []);

  const handlePageview = (resetCounter) => {
    const pv = sessionStorage.getItem('pageViewCount');
    const pageViewCount = pv ? parseInt(pv) : 0;
    sessionStorage.setItem(
      'pageViewCount',
      resetCounter == 0 ? resetCounter : pageViewCount + 1,
    );
    setPageVisitCount(pv);
    if (!customerAccessToken) {
      pv == 2 && setShowCouponModal(true);
    }
  };

  useEffect(() => {
    const pathname = window.location.href; //this gives me current Url
    const isRefreshed = checkIsRefreshed();

    if (isRefreshed) {
      handlePageview(0);
    } else {
      if (currentPage != pathname) {
        if (!pathname.includes('/producto/')) {
          handlePageview();
        }
      }
    }
    if (currentPage != pathname) {
      setTitle('');
      sessionStorage.setItem('isRefreshed', window.location.href);
    }
    if (!pathname.includes('/producto/')) {
      localStorage.setItem('pageUrl', pathname);
    }

    setCurrentPage(window.location.href);
    ReactGA.pageview(window.location.pathname + window.location.search);

    if(!isMobile()){
      setIsDesktop(true)
    }
  }, []);

  const TotalComponentPopulate = () => {
    const {totalQuantity} = useCart();
    return (
      <>
        <div className={`cart-qty h-4 w-4 right-0`}>{totalQuantity}</div>
      </>
    );
  };

  const checkIsRefreshed = () => {
    const isRefreshedURL = sessionStorage.getItem('isRefreshed');
    if (isRefreshedURL == window.location.href) {
      return true;
    }
    return false;
  };

  const handleCloseCouponModal = () => {
    setShowCouponModal(false);
  };

  const handleHomeClick = (evt) => {
    const {target} = evt;
    dataLayer.push({
      event: 'home_click',
    });
  };

  const handlePrimaryMenuClick = (evt, link) => {
    evt.preventDefault();
    const {target} = evt;

    dataLayer.push({
      event: 'menu_primary_click',
      menu: evt.target.innerHTML,
    });

    if (link.title == 'Ofertas') {
      dataLayer.push({
        event: 'select_promotion', //Static data
        creative_name: 'Ofertas ', //Dynamic data
        creative_slot: 'ofertas', //Dynamic data
        promotion_name: 'Ofertas', //Dynamic data
      });
    }

    setTimeout(() => {
      window.location.href = target.href;
    }, 1000);
  };

  const handleSecondaryMenuClick = (evt) => {
    window.location.href = target.href;
  };

  const handleMyInformation = (evt, location ) => {
    evt.preventDefault();
    dataLayer.push({
      event: 'my_information',
      about: evt.target.innerHTML,
      header: 'TRUE',
    });
    window.location.href = `/${location}`
  };

  useEffect(()=>{
  },[isActiveSearch])
  
  const buttonSearchMobile = ()=>{
    setIsActiveSearch(!isActiveSearch);
    dispatch(buttonPhone());
  }

  const defineLoginOrPanel = ()=>{
    if(customerAccessToken){
      return '/account';
    }else{
      let redirectUri = loginUrl;
      return DRUID_AUTH_URL+'oauth2/authorize?client_id='+ DRUID_CLIENT +'&redirect_uri='+ redirectUri +'&response_type=code&request_locale=es_MX';
    }
  }

  return (
    <header
      className={`librero_header bg-gray-60 ${scroll ? 'stick' : ''} `}
      role="banner"
      key="header-1"
    >
      {showCouponModal && (
        <CouponModalComponent onCloseModal={handleCloseCouponModal} />
      )}
      {pending && <Loader />}
      <div className={`fixed z-20 w-full mx-auto ${isMobileNavOpen ? '' : ''}`}>
        <div id="top-bar" className={`${removeTopBar ? 'hidden' : ''}`}>
          <div className={`${(slideNumber === 1) ? 'show-message' : 'hidde-message'}`}>Únete a Club HLM y obtén descuentos en tus compras</div>
          <div className={`${(slideNumber === 2) ? 'show-message' : 'hidde-message'}`}>Envíos gratis a todo México a partir de $599.</div>
        </div>
        <div 
          className={`
            top-header-wrapper flex lg:flex-col justify-center items-center marker:place-content-between py-1 px-5 bg-gray-60 xs:py-2 header-
            ${isActiveSearch ? 'hidden' : 'py-5'}
          `}
        >
          <div 
            className="flex sm:justify-between xs:justify-between  items-center w-full text-center relative xs:h-9 inner-header-wrapper"
          >
            <div className="w-20 lg:w-40 sm:block md:hidden mobile-toggle">
              {
                <MobileNavigation
                  collections={collections}
                  isOpen={isMobileNavOpen}
                  setIsOpen={setIsMobileNavOpen}
                  menu={menu}
                />
              }
            </div>
            <div className="logo-wrapper">
              <Link to="/" onClick={(evt) => handleHomeClick(evt)}>
                <Image src={logo} width={120} height={36} alt="Logo" />
              </Link>
            </div>
            {isDesktop && (
              <div  
                className="search-wrapper sm:visible xs:hidden md:visible flex items-start justify-center px-2 md:w-5/12 2xl:w-5/12 xs:w-full relative lg:ml-28 z-1"
                id="container-home-search"
              >
                <SearchBar isActiveSearch={isActiveSearch} setIsActiveSearch={setIsActiveSearch} />
              </div>
            )}
            <div 
              className={`search-wrapper ${isDesktop ? 'hidden' : ''}`}
            >
                <Image src={SearchIcon} width={40} height={34} alt="Logo" onClick={()=>{ buttonSearchMobile(); }}  />
            </div>
            <div className="header-right gap-5 right-0 w-6/12 xs:w-auto flex justify-end xs:gap-2">
              {!customerAccessToken ? (<>
                <div className="xs-hidden header-icon-link relative xs:hidden sm:hidden">
                  <a href={defineLoginOrPanel()} className="h-text">
                      Mis pedidos
                  </a>
                  <div className="h-icon">
                    <Image
                      src={books}
                      width={24}
                      height={30}
                      alt="books"
                      className="text-3xl px-1"
                    />
                  </div>
                </div>
              </>):(<>
                <div className="xs-hidden header-icon-link relative xs:hidden sm:hidden">
                  <Link to="/account?path=pedidos" className="h-text">
                      Mis pedidos
                    </Link>
                  <div className="h-icon">
                    <Image
                      src={books}
                      width={24}
                      height={30}
                      alt="books"
                      className="text-3xl px-1"
                    />
                  </div>
                </div>              
              </>)}

                <a
                  href={defineLoginOrPanel()}
                  className="header-icon-link relative xs:hidden sm:hidden"
                  id="loggin-user"
                >
                  <div className="h-text">
                    {customerAccessToken ? 'Mi cuenta' : 'Iniciar sesión'}
                  </div>
                  <div className="h-icon">
                    <svg
                      width="27"
                      height="29"
                      viewBox="0 0 27 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.2993 6.45779C10.974 6.16272 11.718 6 12.5011 6C15.538 6 18 8.46252 18 11.5C18 14.5375 15.538 17 12.5011 17C9.46421 17 7 14.5396 7 11.5C7 9.79901 7.77223 8.27594 8.98699 7.26706"
                        stroke="#575FA5"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5 24C6.12099 19.922 9.13775 17 12.6844 17H13.3156C16.8623 17 19.879 19.922 21 24"
                        stroke="#575FA5"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </a>

              <a
                href="/cart"
                className="header-icon-link relative xs:hidden sm:hidden"
                aria-label='Mi bolsa'
                onClick={(evt) => handleMyInformation(evt, 'cart')}
              >
                <div className="h-text relative">Mi bolsa</div>

                <div className="h-icon">
                  <div className="md:visible sm:visible xs:hidden icon-cart relative">
                    <CartProvider
                      onLineUpdate={handleLineUpdate}
                      key={isCartUpdateKey}
                    >
                      <TotalComponentPopulate key={isCartUpdateKey} />
                    </CartProvider>
                    <CartIcon />
                  </div>
                  <div className="md:hidden sm:hidden xs:visible icon-cart relative">
                    <CartProvider
                      onLineUpdate={handleLineUpdate}
                      key={isCartUpdateKey}
                    >
                      <TotalComponentPopulate key={isCartUpdateKey} />
                    </CartProvider>
                    <CartIcon />

                    {/* <CartToggle
                      handleClick={() => {
                        if (isMobileNavOpen) setIsMobileNavOpen(isCartOpen);
                      }}
                    /> */}
                  </div>
                  {/* <CartToggle
                    className="mr-2 flex"
                    handleClick={() => {
                      if (isMobileNavOpen) setIsMobileNavOpen(isCartOpen);
                    }}
                  /> */}
                </div>
              </a>
            </div>
          </div>
          {/* <Navigation collections={collections} storeName={storeName} /> */}
        </div>
          {!isDesktop && (
            <div
              className={`
                sm:hidden xs:visible md:hidden xs:w-full xs:bg-gray-60 xs:p-3 xs:pt-0
                ${isActiveSearch ? 'search-open' : 'hidden'}
              `}
            >
              <SearchBar isActiveSearch={isActiveSearch} setIsActiveSearch={setIsActiveSearch} />
            </div>
          )}
        <div className="header-nav text-xs bg-purple-120 px-5 text-center text-white justify-evenly flex sm:hidden xs:hidden navfon divide-purple-125 space-4">
          {menu
            ? menu?.menu?.map((link) => {
                return (
                  <a
                    href={getPath(link) == '/' ? '/' : '/' + getPath(link)}
                    onClick={(evt) => handlePrimaryMenuClick(evt, link)}
                    className={` ${
                      link.title === selectedTitle
                        ? 'font-semibold underline'
                        : ''
                    } librero-nav-item text-md h-10`}
                    onMouseEnter={(e) => {
                      e.preventDefault();
                      if (link.title != selectedTitle) {
                        setTimeout(() => {
                          const innerText = e.target.innerText;
                          const doc = document.querySelectorAll(':hover');

                          if (doc[doc.length - 1]) {
                            const doc = document.querySelectorAll(':hover');
                            const docHoverText = doc[doc.length - 1].innerText;

                            if (docHoverText == innerText) {
                              setTitle(link.title);
                            }
                          }
                          setTimeOutMenu(100);
                        }, timeOutMenu);
                      }
                    }}
                    key={link.title}
                  >
                    {link.title}
                  </a>
                );
              })
            : ''}
        </div>

        <div className="flex flex-wrap bg-white mx-5 nav-submenu">
          {menu && menu?.menu
            ? menu.menu
                .filter((link) => link.title == selectedTitle)
                .map((item) => {
                  const collectionMenu = item.collectionMenu ? (
                    item.collectionMenu.map((collection) => {
                      const links = collection.links.map((link) => {
                        return (
                          <li key={link._key} className="nav-item">
                            <Link
                              className="relative my-2 flex"
                              to={getPath(link, 'header link')}
                              reloadDocument="true"
                            >
                              {link.text}
                              {link?.image ? (
                                <div className="nf-icon rounded-full h-12 w-12 bg-white border-2 border-purple-120 flex justify-center items-center absolute right-0">
                                  <Image
                                    src={link?.image.asset.url}
                                    height={10}
                                    width={20}
                                  />
                                </div>
                              ) : (
                                ''
                              )}
                            </Link>
                          </li>
                        );
                      });

                      return (
                        <div
                          key={collection._key}
                          className="nav-featured-wrapper"
                        >
                          <ul className="nav-featured-list">{links}</ul>
                        </div>
                      );
                    })
                  ) : (
                    <></>
                  );
                  const submenu = item?.submenu ? (
                    
                    item.submenu.map((collection) => {
                      
                      // if(collection?.title === "Nuestros autores"){
                      //   let existOption = collection?.links.some(element => element._key === 'a4b092729999');
                        
                      //   if(!existOption){
                      //     collection?.links.push(
                      //       {
                      //         "_type": "list",
                      //         "text": "Ver autores",
                      //         "_key": "a4b092729999",
                      //         "type": "URL",
                      //         "url": "/autores",
                      //         "category": null,
                      //         "pageCategory": null,
                      //         "labels": {
                      //             "title": "Ver autores",
                      //             "_updatedAt": "2024-03-26T22:56:52Z",
                      //             "slug": {
                      //                 "current": "autores",
                      //                 "_type": "slug"
                      //             },
                      //             "defaultSorting": "date",
                      //             "_createdAt": "2024-03-26T22:56:52Z",
                      //             "_rev": "8YdmpocxPgqGGbKJjzZ6cN",
                      //             "_type": "label",
                      //             "_id": "0a3ee02a-289d-4e3a-80e0-f4930292c187"
                      //         },
                      //         "image": null,
                      //         "collection": null,
                      //         "page": null
                      //       }
                      //     );
                      //   }
                      // }

                      const links = collection?.links ? (
                        collection.links.map((link) => (
                          <li
                            key={link._key}
                            className="nav-item"
                            menuTitle="test"
                          >

                              <Link
                                to={getPath(link, 'header link sub')}
                                onClick={(evt) => handleSecondaryMenuClick(evt)}
                              >
                                {link.text}
                              </Link>
                              
                          </li>
                        ))
                      ) : (
                        <></>
                      );
                      return (
                        <>
                          <div
                            key={collection._key}
                            className={`md:w-3/12 lg:w-4/12 xl:w-4/12 2xl:w-3/12 nav-column nav-column-group 
                            ${
                              links.length > 0
                                ? ' with-submenu '
                                : ' no-submenu'
                            }
                            ${links.length > 10 ? ' submenu-2-columns ' : ''}`}
                          >
                            <Link
                              to={getPath(collection)}
                              onClick={(evt) => handleSecondaryMenuClick(evt)}
                              replace={false}
                            >
                              <h3 className="nav-column-header">
                                {collection.title} >
                              </h3>
                            </Link>
                            <ul>{links}</ul>
                          </div>
                          {links.length >= 3 && (
                            <div className="hidden">&nbsp;</div>
                          )}
                        </>
                      );
                    })
                  ) : (
                    <></>
                  );

                  const featured = (item) => {
                    return (
                      <>
                      {item?.featuredImage?.image && (
                        <div className="nav-banner">
                          <div className="">
                          
                            <div className="flex flex-wrap justify-center items-center">
                              
                                <div className="w-full relative">
                                  <div
                                    className="nav-image-banner"
                                    style={{
                                      backgroundImage: `url(${item?.featuredImage?.image.asset.url})`,
                                    }}
                                  ></div>
                                  <p
                                    className="absolute left-5 top-0 w-8/12 text-white text-2xl font-semibold px-2 py-5
                                  "
                                  >
                                    {item.featuredImage.text}
                                  </p>
                                  <div className="nav-banner-bottom absolute bottom-6 w-full flex">
                                    <Link
                                      to={getPath(item.featuredImage, 'featured')}
                                      className="nav-banner-button rounded-full px-10 py-2  text-white font-semibold bg-purple-120"
                                    >
                                      {item.featuredImage.buttonText}
                                    </Link>
                                  </div>
                                </div>
                              
                            </div>
                          
                          </div>
                        </div>
                      )}
                      </>
                    );
                  };

                  if (!item.collectionMenu && !item.submenu) {
                    return <></>;
                  } else {
                    return (
                      <div
                        className="w-full nav-submenu-wrapper"
                        key={item._key}
                        onMouseLeave={() => {
                          setTitle('');
                        }}
                      >
                        <div className="w-full bg-gray-200 nav-header">
                          <div  className='col-link-view-all name-category'>
                            {item.title} 
                          </div>
                          <div className='col-link-view-all view-more-col'>
                            <Link to={'/categoria-producto/'+item.categorytags?.slug?.current} className="link-head">
                              Ver todos
                            </Link>
                          </div>
                          <div  className='col-link-view-all button-close'>
                            <button
                              className="float-right"
                              onClick={() => setTitle('')}
                            >
                              <Image src={close} width={33} height={33} />
                            </button>
                          </div>
                        </div>
                        <div className="flex flex-wrap nav-content justify-between h-100">
                          {item.collectionMenu && (
                            <div className="lg:w-1/5 featured-container">
                              <div className='col-options-title'>
                                <h3 class="nav-column-header nav-title-col">{item?.collectionMenu[0].title}</h3>
                              </div>
                              <div className='col-options-submenu'>
                                {' '}
                                {collectionMenu}{' '}
                              </div>
                            </div>
                          )}
                          <div className="lg:w-3/5 md:w-full sm:w-1/3 flex-wrap flex nav-menu-left">
                            {submenu}{' '}
                          </div>
                          <div className="lg:w-1/5 rigth-column">
                            {featured(item)}{' '}
                          </div>
                        </div>
                      </div>
                    );
                  }
                })
            : ''}
        </div>
      </div>
    </header>
  );
}
